import type { Guest, Rsvp, Side } from '../../types/board';

const cols = 'grid grid-cols-[1.6fr_1fr_1fr_0.8fr_0.8fr_1.4fr_40px]';
const rsvpColors: Record<Rsvp, string> = {
  pending: 'oklch(45% 0.02 50)',
  confirmed: 'oklch(46% 0.07 145)',
  declined: 'oklch(50% 0.1 20)',
};

export default function GuestTable({
  guests,
  onAdd,
  onUpdate,
  onRemove,
  readOnly = false,
  onToggleCheckedIn,
}: {
  guests: Guest[];
  onAdd: () => void;
  onUpdate: (id: string, patch: Partial<Guest>) => void;
  onRemove: (id: string) => void;
  readOnly?: boolean;
  onToggleCheckedIn?: (id: string, checkedIn: boolean) => void;
}) {
  return (
    <div className="overflow-x-auto">
      <div className="border border-line bg-card min-w-[760px]">
      <div className={`${cols} px-4.5 py-3 border-b border-line text-[11px] font-bold uppercase tracking-wider text-muted`}>
        <span>Name</span>
        <span>Side</span>
        <span>RSVP</span>
        <span>Plus-one</span>
        <span>Checked in</span>
        <span>Notes</span>
        <span />
      </div>
      {guests.map((g) => (
        <div key={g.id} className={`${cols} items-center px-4.5 py-2.5 border-b border-[oklch(92%_0.012_60)]`}>
          <input
            value={g.name}
            disabled={readOnly}
            onChange={(e) => onUpdate(g.id, { name: e.target.value })}
            className="border-none bg-transparent text-sm px-1 py-1 rounded hover:bg-cream focus:bg-cream focus:outline focus:outline-1 focus:outline-line disabled:opacity-70 disabled:hover:bg-transparent"
          />
          <select
            value={g.side}
            disabled={readOnly}
            onChange={(e) => onUpdate(g.id, { side: e.target.value as Side })}
            className="border-none bg-transparent text-sm px-1 py-1 disabled:opacity-70"
          >
            <option value="bride">Bride's side</option>
            <option value="groom">Groom's side</option>
            <option value="both">Both</option>
          </select>
          <span
            className="text-xs font-semibold rounded-full px-2 py-1 justify-self-start"
            style={{ background: 'oklch(96% 0.01 60)', color: rsvpColors[g.rsvp] }}
          >
            {g.rsvp.charAt(0).toUpperCase() + g.rsvp.slice(1)}
          </span>
          <input
            type="checkbox"
            checked={g.plusOne}
            disabled={readOnly}
            onChange={(e) => onUpdate(g.id, { plusOne: e.target.checked })}
            className="accent-terra w-4 h-4 justify-self-center disabled:opacity-70"
          />
          <input
            type="checkbox"
            checked={g.checkedIn}
            onChange={(e) =>
              readOnly && onToggleCheckedIn
                ? onToggleCheckedIn(g.id, e.target.checked)
                : onUpdate(g.id, { checkedIn: e.target.checked })
            }
            className="accent-sage w-[18px] h-[18px] justify-self-center"
          />
          <input
            value={g.notes}
            disabled={readOnly}
            onChange={(e) => onUpdate(g.id, { notes: e.target.value })}
            placeholder="—"
            className="border-none bg-transparent text-xs text-muted px-1 py-1 rounded hover:bg-cream focus:bg-cream focus:outline focus:outline-1 focus:outline-line disabled:opacity-70 disabled:hover:bg-transparent"
          />
          {!readOnly && (
            <button onClick={() => onRemove(g.id)} className="text-terra justify-self-center">
              ×
            </button>
          )}
        </div>
      ))}
      {!readOnly && (
        <button onClick={onAdd} className="w-full text-left pl-4.5 py-3.5 text-sm text-muted hover:text-terra">
          + Add guest
        </button>
      )}
      </div>
    </div>
  );
}
